import { render, staticRenderFns } from "./HangupIcon.vue?vue&type=template&id=20ab4678"
import script from "./HangupIcon.vue?vue&type=script&lang=ts"
export * from "./HangupIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports